module.exports = __webpack_public_path__ + "static/media/de.246a5fcb.svg";